const typelists = {
  GenderType: [
    { name: "Male", code: "M" },
    { name: "Female", code: "F" },
    { name: "Unknown", code: "U" }
  ],

  SubmitterType: [
    { name: "Injured Worker", code: "InjuredWorker" },
    { name: "Attorney", code: "Attorney" },
    { name: "Employer", code: "Employer" },
    { name: "Medical Provider", code: "MedicalProvider" },
    { name: "Other", code: "Other" }
  ],
  WagesPaidType: [
    { name: "Hour", code: "Hour" },
    { name: "Day", code: "Day" },
    { name: "Week", code: "Week" },
    { name: "Month", code: "Month" },
    { name: "Year", code: "Year" }
  ],
  EmploymentStatus: [
    { name: "Regular Full - Time", code: "F" },
    { name: "Part-Time", code: "P" },
    { name: "Temporary", code: "T" },
    { name: "Seasonal", code: "S" }
  ],
  DetailedInjury: {
    "79": "79 Hepatitis C",
    "78": "78 Carpal Tunnel Syndrome",
    "77": "77 Mental stress",
    "36": "36 Infection",
    "34": "34 Hernia",
    "37": "37 Inflammation",
    "43": "43 Puncture",
    "42": "42 Poisoning (not overdose or cumulative injury)",
    "41": "41 Myocardial infarction",
    "40": "40 Laceration",
    "80": "80 All other cumulative injuries",
    "67": "67 Poisoning (metal)",
    "66": "66 Poisoning (chemical)",
    "69": "69 Mental disorder",
    "68": "68 Dermatitis",
    "22": "22 Enucleation",
    "25": "25 Foreign body",
    "28": "28 Fracture",
    "30": "30 Freezing",
    "32": "32 Heat prostration",
    "31": "31 Hearing loss or impairment",
    "70": "70 Radiation",
    "71": "71 All other occupational disease injuries",
    "72": "72 Loss of hearing",
    "73": "73 Contagious disease",
    "74": "74 Cancer",
    "75": "75 AIDS",
    "76": "76 VDT (Video display terminal) diseases",
    "59": "59 All Other specific injury",
    "58": "58 Vision Loss",
    "19": "19 Electric shock",
    "55": "55 Vascular",
    "16": "16 Dislocation",
    "13": "13 Crushing",
    "64": "64 Silicosis",
    "65": "65 Respiratory disorders (gases, fumes, chemicals)",
    "62": "62 Black lung",
    "63": "63 Byssinosis",
    "60": "60 Dust disease",
    "61": "61 Asbestosis",
    "49": "49 Sprain",
    "47": "47 Severance",
    "91": "91 Multiple injuries including both physical and psychological",
    "46": "46 Rupture",
    "90": "90 Multiple physical injuries only",
    "04": "04 Burn",
    "07": "07 Concussion",
    "01": "01 No Physical Injury",
    "02": "02 Amputation",
    "03": "03 Angina pectoris",
    "10": "10 Contusion",
    "52": "52 Strain",
    "53": "53 Syncope",
    "54": "54 Asphyxiation"
  },
  DetailedBodyPart: {
    "61": "Abdomen including groin",
    "55": "Ankle",
    "64": "Artificial appliance",
    "91": "Body Systems and Multiple Body Systems",
    "12": "Brain",
    "62": "Buttocks",
    "44": "Chest",
    "43": "Disc (back)",
    "22": "Disc (neck)",
    "13": "Ear(s)",
    "32": "Elbow",
    "14": "Eye(s)",
    "19": "Facial bones",
    "36": "Finger(s)",
    "56": "Foot",
    "58": "Great toe",
    "35": "Hand",
    "49": "Heart",
    "51": "Hip",
    "48": "Internal organs",
    "53": "Knee",
    "24": "Larynx",
    "33": "Lower arm",
    "42": "Lower back area",
    "54": "Lower leg",
    "63": "Lumbar or sacral vertebrae",
    "60": "Lungs",
    "17": "Mouth",
    "90": "Multiple body parts (Including Body Systems & Body Parts)",
    "10": "Multiple head injuries",
    "50": "Multiple lower extremities",
    "20": "Multiple neck injuries",
    "40": "Multiple trunk injuries",
    "30": "Multiple upper extremities",
    "66": "No physical injury",
    "15": "Nose",
    "46": "Pelvis",
    "45": "Sacrum and coccyx",
    "38": "Shoulder(s)",
    "11": "Skull",
    "18": "Soft tissue (head)",
    "25": "Soft tissue (neck)",
    "47": "Spinal cord (back)",
    "23": "Spinal cord (neck)",
    "16": "Teeth",
    "37": "Thumb",
    "57": "Toes",
    "26": "Trachea",
    "65": "Unclassified - insufficient info to properly identify",
    "31": "Upper arm",
    "41": "Upper back area",
    "52": "Upper leg",
    "21": "Vertebrae",
    "39": "Wrist(s) and Hand(s)",
    "34": "Wrist"
  },
  DetailedBodyPartSorted: {
    "Abdomen including groin" :"61" ,
    "Ankle" :"55" ,
    "Artificial appliance" :"64" ,
    "Body Systems and Multiple Body Systems" :"91" ,
    "Brain" :"12" ,
    "Buttocks" :"62" ,
    "Chest" :"44" ,
    "Disc (back)" :"43" ,
    "Disc (neck)" :"22" ,
    "Ear(s)" :"13" ,
    "Elbow" :"32" ,
    "Eye(s)" :"14" ,
    "Facial bones" :"19" ,
    "Finger(s)" :"36" ,
    "Foot" :"56" ,
    "Great toe" :"58" ,
    "Hand" :"35" ,
    "Heart" :"49" ,
    "Hip" :"51" ,
    "Internal organs" :"48" ,
    "Knee" :"53" ,
    "Larynx" :"24" ,
    "Lower arm" :"33" ,
    "Lower back area" :"42" ,
    "Lower leg" :"54" ,
    "Lumbar or sacral vertebrae" :"63" ,
    "Lungs" :"60" ,
    "Mouth" :"17" ,
    "Multiple body parts (Including Body Systems & Body Parts)" :"90" ,
    "Multiple head injuries" :"10" ,
    "Multiple lower extremities" : "50",
    "Multiple neck injuries" : "20" ,
    "Multiple trunk injuries" :"40" ,
    "Multiple upper extremities" :"30" ,
    "No physical injury" :"66" ,
    "Nose" :"15" ,
    "Pelvis" :"46" ,
    "Sacrum and coccyx" :"45" ,
    "Shoulder(s)" :"38" ,
    "Skull" :"11" ,
    "Soft tissue (head)" :"18" ,
    "Soft tissue (neck)" :"25" ,
    "Spinal cord (back)" :"47" ,
    "Spinal cord (neck)" :"23" ,
    "Teeth" :"16" ,
    "Thumb" :"37" ,
    "Toes" :"57" ,
    "Trachea" :"26" ,
    "Unclassified - insufficient info to properly identify" :"65" ,
    "Upper arm" :"31" ,
    "Upper back area" :"41" ,
    "Upper leg" :"52" ,
    "Vertebrae" :"21" ,
    "Wrist(s) and Hand(s)" :"39" ,
    "Wrist" :"34"
  },
  Country: {
    VU: "Vanuatu",
    VN: "Vietnam",
    EC: "Ecuador",
    VI: "U.S. Virgin Islands",
    DZ: "Algeria",
    VG: "British Virgin Islands",
    VE: "Venezuela",
    DM: "Dominica",
    VC: "St. Vincent and the Grenadines",
    DO: "Dominican Republic",
    VA: "Vatican City",
    DE: "Germany",
    UZ: "Uzbekistan",
    UY: "Uruguay",
    DK: "Denmark",
    DJ: "Djibouti",
    US: "United States",
    UM: "U.S. Minor Outlying Islands",
    UG: "Uganda",
    UA: "Ukraine",
    ET: "Ethiopia",
    ES: "Spain",
    ER: "Eritrea",
    EH: "Western Sahara",
    EG: "Egypt",
    TZ: "Tanzania",
    EE: "Estonia",
    TT: "Trinidad and Tobago",
    TW: "Taiwan",
    TV: "Tuvalu",
    GD: "Grenada",
    GE: "Georgia",
    GF: "French Guiana",
    GA: "Gabon",
    GB: "United Kingdom",
    FR: "France",
    FO: "Faroe Islands",
    FK: "Falkland Islands (Malvinas)",
    FJ: "Fiji, Republic of the Fiji Islands",
    FM: "Micronesia, Federated States of",
    FI: "Finland",
    WS: "Samoa",
    GY: "Guyana",
    GW: "Guinea-Bissau",
    GU: "Guam",
    GT: "Guatemala",
    GS: "South Georgia and the South Sandwich Islands",
    GR: "Greece",
    GQ: "Equatorial Guinea",
    WF: "Wallis and Futuna Islands",
    GP: "Guadeloupe",
    GN: "Guinea",
    GM: "Gambia",
    GL: "Greenland",
    GI: "Gibraltar",
    GH: "Ghana",
    RE: "Reunion",
    RO: "Romania",
    AT: "Austria",
    AS: "American Samoa",
    AR: "Argentina",
    AQ: "Antarctica",
    AW: "Aruba",
    QA: "Qatar",
    AU: "Australia",
    AZ: "Azerbaijan",
    BA: "Bosnia and Herzegovina",
    PT: "Portugal",
    AD: "Andorra",
    PW: "Palau",
    AG: "Antigua and Barbuda",
    AE: "United Arab Emirates",
    PR: "Puerto Rico",
    AF: "Afghanistan",
    PS: "Palestinian Interim Self-Government Authority",
    AL: "Albania",
    AI: "Anguilla",
    AO: "Angola",
    PY: "Paraguay",
    AM: "Armenia",
    AN: "Netherlands Antilles",
    TG: "Togo",
    BW: "Botswana",
    TF: "French Southern Territories",
    BV: "Bouvet Island (Bouvetoya)",
    BY: "Belarus",
    TD: "Chad",
    TK: "Tokelau (Tokelau Islands)",
    BS: "Bahamas",
    TJ: "Tajikistan",
    BR: "Brazil",
    TH: "Thailand",
    BT: "Bhutan",
    TO: "Tonga",
    TN: "Tunisia",
    TM: "Turkmenistan",
    TL: "Timor-Leste",
    CA: "Canada",
    TR: "Turkey",
    BZ: "Belize",
    BF: "Burkina Faso",
    SV: "El Salvador",
    BG: "Bulgaria",
    BH: "Bahrain",
    BI: "Burundi",
    ST: "Sao Tome and Principe",
    SY: "Syria",
    BB: "Barbados",
    SZ: "Swaziland",
    BD: "Bangladesh",
    BE: "Belgium",
    BN: "Brunei",
    BO: "Bolivia",
    BJ: "Benin",
    TC: "Turks and Caicos Islands",
    BL: "Saint Barthelemy",
    BM: "Bermuda",
    SD: "Sudan",
    CZ: "Czech Republic",
    CY: "Cyprus",
    SC: "Seychelles",
    CX: "Christmas Island",
    SE: "Sweden",
    SH: "St. Helena",
    CV: "Cape Verde",
    CU: "Cuba",
    SG: "Singapore",
    SJ: "Svalbard and Jan Mayen Islands",
    SI: "Slovenia",
    SL: "Sierra Leone",
    SK: "Slovakia",
    SN: "Senegal",
    SM: "San Marino",
    SO: "Somalia",
    SR: "Suriname",
    CI: "Ivory Coast",
    RS: "Serbia",
    CG: "Congo - Brazzaville",
    CH: "Switzerland",
    RU: "Russia",
    CF: "Central African Republic",
    RW: "Rwanda",
    CC: "Cocos (Keeling) Islands",
    CD: "Congo - Kinshasa",
    CR: "Costa Rica",
    CO: "Colombia",
    CM: "Cameroon",
    CN: "China",
    CK: "Cook Islands",
    SA: "Saudi Arabia",
    SB: "Solomon Islands",
    CL: "Chile",
    LV: "Latvia",
    LU: "Luxembourg",
    LT: "Lithuania",
    LY: "Libya",
    LS: "Lesotho",
    LR: "Liberia",
    MG: "Madagascar",
    MH: "Marshall Islands",
    ME: "Montenegro",
    MF: "Saint Martin",
    MK: "Macedonia",
    ML: "Mali",
    MC: "Monaco",
    MD: "Moldova",
    MA: "Morocco",
    MV: "Maldives",
    MU: "Mauritius",
    MX: "Mexico",
    MW: "Malawi",
    MZ: "Mozambique",
    MY: "Malaysia",
    MN: "Mongolia",
    MM: "Myanmar [Burma]",
    MP: "Northern Mariana Islands",
    MO: "Macau SAR China",
    MR: "Mauritania",
    MQ: "Martinique",
    MT: "Malta",
    MS: "Montserrat",
    NF: "Norfolk Island",
    NG: "Nigeria",
    NI: "Nicaragua",
    NL: "Netherlands",
    NA: "Namibia",
    NC: "New Caledonia",
    NE: "Niger",
    NZ: "New Zealand",
    NU: "Niue",
    NR: "Nauru",
    NP: "Nepal",
    NO: "Norway",
    OM: "Oman",
    PL: "Poland",
    PM: "St. Pierre and Miquelon",
    PN: "Pitcairn Island",
    PH: "Philippines",
    PK: "Pakistan",
    PE: "Peru",
    PF: "French Polynesia",
    PG: "Papua New Guinea",
    PA: "Panama",
    HK: "Hong Kong SAR China",
    ZA: "South Africa",
    HN: "Honduras",
    HM: "Heard and McDonald Islands",
    HR: "Croatia",
    HT: "Haiti",
    HU: "Hungary",
    ZM: "Zambia",
    ZW: "Zimbabwe",
    ID: "Indonesia",
    IE: "Ireland",
    IL: "Israel",
    IN: "India",
    IO: "British Indian Ocean Territory (Chagos Archipelago)",
    IQ: "Iraq",
    IR: "Iran",
    YE: "Yemen",
    IS: "Iceland",
    IT: "Italy",
    YT: "Mayotte",
    JP: "Japan",
    JO: "Jordan",
    JM: "Jamaica",
    KI: "Kiribati",
    KH: "Cambodia",
    KG: "Kyrgyz Republic",
    KE: "Kenya",
    KP: "Korea, North",
    KR: "Korea, South",
    KM: "Comoros",
    KN: "St. Kitts and Nevis",
    KW: "Kuwait",
    KY: "Cayman Islands",
    KZ: "Kazakhstan",
    LA: "Laos",
    LC: "St. Lucia",
    LB: "Lebanon",
    LI: "Liechtenstein",
    LK: "Sri Lanka"
  },
  AccidentType: {
    "79": "79-Struck or injured by object being lifted or handled",
    "78": "78-Struck or injured by moving parts of machine",
    "77": "77-Struck or injured by motor vehicle",
    "33": "33-Fall, slip, or trip injury on stairs",
    "41": "41-Crash of rail vehicle",
    "40": "40-Crash of water vehicle",
    "82": "82-Absorption, ingestion, or inhalation, miscellaneous",
    "80": "80-Struck or injured by object handled by others",
    "81": "81-Struck or injured, miscellaneous",
    "86": "86-Struck or injured by explosion or flare back",
    "87": "87-Foreign matter (body) in eye(s)",
    "84": "84-Contact with electrical current",
    "85": "85-Struck or injured by animal or insect",
    "67": "67-Striking against or stepping on sanding, scraping, cleaning operation",
    "66": "66-Striking against or stepping on object being lifted or handled",
    "69": "69-Stepping on sharp object",
    "68": "68-Striking against or stepping on stationary object",
    "25": "25-Fall, slip, or trip injury from different level (elevation)",
    "26": "26-Fall, slip, or trip injury from ladder or scaffolding",
    "27": "27-Fall, slip, or trip injury from liquid or grease spills",
    "28": "28-Fall, slip, or trip injury into openings",
    "29": "29-Fall, slip, or trip injury on same level",
    "30": "30-Slipped, do not fall",
    "32": "32-Fall, slip, or trip injury on ice or snow",
    "31": "31-Fall, slip, or trip injury, miscellaneous",
    "70": "70-Striking against or stepping on miscellaneous",
    "74": "74-Struck or injured by fellow worker; patient",
    "75": "75-Struck or injured by falling or flying object",
    "76": "76-Struck or injured by hand tool or machine in use",
    "59": "59-Strain or injury by using tool or machinery",
    "58": "58-Strain or injury by reaching",
    "57": "57-Strain or injury by pushing or pulling",
    "19": "19-Cut, puncture, scrape, injured by miscellaneous",
    "56": "56-Strain or injury by lifting",
    "55": "55-Strain or injury by holding or carrying",
    "17": "17-Cut, puncture, scrape, injured by object being lifted or handled",
    "18": "18-Cut, puncture, scrape, injured by powered hand tool, appliance",
    "15": "15-Cut, puncture, scrape, injured by broken glass",
    "16": "16-Cut, puncture, scrape, injured by hand tool, utensil; not powered",
    "13": "13-Caught in, under, or between miscellaneous",
    "14": "14-Contact with abnormal air pressure",
    "11": "11-Contact with Cold Objects or Substances",
    "12": "12-Caught in, under, or between object handled",
    "20": "20-Caught in, under, or between collapsing materials (slides of earth)",
    "65": "65-Striking against or stepping on moving part of machine",
    "99": "99-Miscellaneous - other",
    "60": "60-Strain or injury by miscellaneous",
    "61": "61-Strain or injury by wielding or throwing",
    "98": "98-Miscellaneous - cumulative, miscellaneous",
    "48": "48-Vehicle upset",
    "97": "97-Strain or injury by repetitive motion",
    "96": "96-Terrorism",
    "95": "95-Rubbed or abraded, miscellaneous",
    "94": "94-Rubbed or abraded by repetitive motion",
    "08": "08-Contact with radiation",
    "45": "45-Collision or sideswipe with another vehicle",
    "93": "93-Gunshot",
    "09": "09-Contact with, NOC",
    "47": "47-Crash of airplane",
    "91": "91-Mold",
    "46": "46-Collision with a fixed object",
    "90": "90-Miscellaneous - other than physical cause of injury",
    "04": "04-Contact with fire or flame",
    "05": "05-Contact with steam or hot fluids",
    "06": "06-Contact with dust, gases, fumes, or vapors",
    "07": "07-Contact with welding operation",
    "01": "01-Contact with chemicals",
    "02": "02-Contact with hot objects or substances",
    "03": "03-Contact with temperature extremes",
    "10": "10-Caught in, under, or between machine or machinery",
    "52": "52-Strain or injury by continual noise",
    "53": "53-Strain or injury by twisting",
    "54": "54-Strain or injury by jumping",
    "88": "88-Natural disasters",
    "89": "89-Person in act of a crime",
    "50": "50-Motor vehicle, miscellaneous"
  },
  StatesFiltered: {
    AK: "Alaska",
    AL: "Alabama",
    AR: "Arkansas",
    AZ: "Arizona",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DC: "District of Columbia",
    DE: "Delaware",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    IA: "Iowa",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    MA: "Massachusetts",
    MD: "Maryland",
    ME: "Maine",
    MI: "Michigan",
    MN: "Minnesota",
    MO: "Missouri",
    MS: "Mississippi",
    MT: "Montana",
    NC: "North Carolina",
    ND: "North Dakota",
    NE: "Nebraska",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NV: "Nevada",
    NY: "New York",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VA: "Virginia",
    VT: "Vermont",
    WA: "Washington",
    WI: "Wisconsin",
    WV: "West Virginia",
    WY: "Wyoming"
  },
  States: {
    AB: "Alberta",
    ACT: "Australian Capital Territory",
    AGU: "Aguascalientes",
    Aichi: "Aichi",
    AK: "Alaska",
    Akita: "Akita",
    AL: "Alabama",
    ANW: "Antwerp",
    Aomori: "Aomori",
    AR: "Arkansas",
    AU_ACT: "A.C.T.",
    AU_JBT: "Jervis Bay Territory",
    AU_NSW: "New South Wales",
    AU_NT: "Northern Territory",
    AU_QLD: "Queensland",
    AU_SA: "South Australia",
    AU_TAS: "Tasmania",
    AU_VIC: "Victoria",
    AU_WA: "Western Australia",
    AZ: "Arizona",
    BC: "British Columbia",
    BCN: "Baja California",
    BCS: "Baja California Sur",
    BFS: "Bedfordshire",
    BHS: "Buckinghamshire",
    BR: "Barcelona",
    BRI: "Bristol",
    BRS: "Brussels",
    BSH: "Berkshire",
    CA: "California",
    CAM: "Campeche",
    CBS: "Cambridgeshire",
    CDUR: "County Durham",
    CHB: "Chubu",
    CHG: "Chugoku",
    CHH: "Chihuahua",
    Chiba: "Chiba",
    CHP: "Chiapas",
    CO: "Colorado",
    COA: "Coahuila",
    COL: "Colima",
    CRIA: "Cumbria",
    CSH: "Cheshire",
    CT: "Connecticut",
    CWL: "Cornwall",
    DC: "District of Columbia",
    DE: "Delaware",
    DE_BB: "Brandenburg",
    DE_BE: "Berlin",
    DE_BW: "Baden-Wuerttemberg",
    DE_BY: "Bavaria",
    DE_HB: "Bremen",
    DE_HE: "Hesse",
    DE_HH: "Hamburg",
    DE_MV: "Mecklenburg-Vorpommern",
    DE_NI: "Lower Saxony",
    DE_NW: "North Rhine-Westphalia",
    DE_RP: "Rhineland-Palatinate",
    DE_SH: "Schleswig-Holstein",
    DE_SL: "Saarland",
    DE_SN: "Saxony",
    DE_ST: "Saxony-Anhalt",
    DE_TH: "Thuringia",
    DIF: "Distrito Federal",
    DSET: "Dorset",
    DSH: "Derbyshire",
    DUR: "Durango",
    DVN: "Devon",
    EAF: "East Flanders",
    Ehime: "Ehime",
    ERY: "East Riding of Yorkshire",
    ESU: "East Sussex",
    ESX: "Essex",
    FBR: "Flemish Brabant",
    FL: "Florida",
    FM: "Federated States of Micronesia",
    Fukui: "Fukui",
    Fukuoka: "Fukuoka",
    Fukushima: "Fukushima",
    GA: "Georgia",
    Gifu: "Gifu",
    GMC: "Greater Manchester",
    GRO: "Guerrero",
    GSH: "Gloucestershire",
    GU: "Guam",
    GUA: "Guanajuato",
    Gumma: "Gumma",
    HAT: "Hainaut",
    HES: "Hertfordshire",
    HI: "Hawaii",
    HID: "Hidalgo",
    Hiroshima: "Hiroshima",
    HOK: "Hokkaido",
    Hokkaido: "Hokkaido",
    HRS: "Herefordshire",
    HSH: "Hampshire",
    Hyogo: "Hyogo",
    IA: "Iowa",
    Ibaraki: "Ibaraki",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    Ishikawa: "Ishikawa",
    Iwate: "Iwate",
    IWT: "Isle of Wight",
    JAL: "Jalisco",
    Kagawa: "Kagawa",
    Kagoshima: "Kagoshima",
    Kanagawa: "Kanagawa",
    KNT: "Kent",
    Kochi: "Kochi",
    KS: "Kansas",
    KSI: "Kansai",
    KTO: "Kanto",
    Kumamoto: "Kumamoto",
    KY: "Kentucky",
    Kyoto: "Kyoto",
    KYU: "Kyushu",
    LA: "Louisiana",
    LCS: "Leicestershire",
    LG: "Liege",
    LIS: "Lincolnshire",
    LMB: "Limburg",
    LSH: "Lancashire",
    LXB: "Luxembourg",
    MA: "Massachusetts",
    MB: "Manitoba",
    MD: "Maryland",
    ME: "Maine",
    MEX: "México",
    MH: "Marshall Islands",
    MI: "Michigan",
    MIC: "Michoacán",
    Mie: "Mie",
    Miyagi: "Miyagi",
    Miyazaki: "Miyazaki",
    MN: "Minnesota",
    MO: "Missouri",
    MOR: "Morelos",
    MP: "Northern Mariana Islands",
    MRS: "Merseyside",
    MS: "Mississippi",
    MT: "Montana",
    Nagano: "Nagano",
    Nagasaki: "Nagasaki",
    Nara: "Nara",
    NAY: "Nayarit",
    NB: "New Brunswick",
    NC: "North Carolina",
    ND: "North Dakota",
    NE: "Nebraska",
    NFK: "Norfolk",
    NH: "New Hampshire",
    NHL: "Northumberland",
    NHS: "Northamptonshire",
    Niigata: "Niigata",
    NJ: "New Jersey",
    NL: "Newfoundland and Labrador",
    NLE: "Nuevo León",
    NM: "New Mexico",
    NMR: "Namur",
    NOT: "Northern Territory",
    NS: "Nova Scotia",
    NSH: "Nottinghamshire",
    NSW: "New South Wales",
    NT: "Northwest Territories",
    NU: "Nunavut",
    NV: "Nevada",
    NY: "New York",
    NYS: "North Yorkshire",
    OAX: "Oaxaca",
    OH: "Ohio",
    Oita: "Oita",
    OK: "Oklahoma",
    Okayama: "Okayama",
    Okinawa: "Okinawa",
    OKW: "Okinawa",
    ON: "Ontario",
    OR: "Oregon",
    Osaka: "Osaka",
    OSH: "Oxfordshire",
    PA: "Pennsylvania",
    PAMP: "Pampanga",
    PE: "Prince Edward Island",
    PR: "Puerto Rico",
    PUE: "Puebla",
    QC: "Quebec",
    QLD: "Queensland",
    QUE: "Querétaro",
    RI: "Rhode Island",
    RLN: "Rutland",
    ROO: "Quintana Roo",
    SA: "South Australia",
    Saga: "Saga",
    Saitama: "Saitama",
    SC: "South Carolina",
    SD: "South Dakota",
    SFK: "Suffolk",
    SHI: "Shikoku",
    Shiga: "Shiga",
    Shimane: "Shimane",
    Shizuoka: "Shizuoka",
    SIN: "Sinaloa",
    SK: "Saskatchewan",
    SLP: "San Luis Potosí",
    SON: "Sonora",
    SRY: "Surrey",
    SSH: "Shropshire",
    SST: "Somerset",
    SSX: "Sussex",
    STS: "Staffordshire",
    SYS: "South Yorkshire",
    TAB: "Tabasco",
    TAM: "Tamaulipas",
    TAS: "Tasmania",
    TLA: "Tlaxcala",
    TN: "Tennessee",
    TNW: "Tyne and Wear",
    Tochigi: "Tochigi",
    TOH: "Tohoku",
    Tokushima: "Tokushima",
    Tokyo: "Tokyo",
    Tottori: "Tottori",
    Toyama: "Toyama",
    TX: "Texas",
    UT: "Utah",
    VA: "Virginia",
    VER: "Veracruz",
    VI: "Virgin Islands",
    VIC: "Victoria",
    VT: "Vermont",
    WA: "Washington",
    Wakayama: "Wakayama",
    WAU: "Western Australia",
    WFL: "West Flanders",
    WI: "Wisconsin",
    WIS: "Wiltshire",
    WLB: "Walloon Brabant",
    WML: "West Midlands",
    WSH: "Worcestershire",
    WSX: "West Sussex",
    WV: "West Virginia",
    WWS: "Warwickshire",
    WY: "Wyoming",
    WYS: "West Yorkshire",
    Yamagata: "Yamagata",
    Yamaguchi: "Yamaguchi",
    Yamanashi: "Yamanashi",
    YSH: "Yorkshire",
    YT: "Yukon",
    YUC: "Yucatán",
    ZAC: "Zacatecas"
  },
  CountriesObjs: [
    { name: "Afghanistan", code: "AF" },
    { name: "Åland Islands", code: "AX" },
    { name: "Albania", code: "AL" },
    { name: "Algeria", code: "DZ" },
    { name: "American Samoa", code: "AS" },
    { name: "AndorrA", code: "AD" },
    { name: "Angola", code: "AO" },
    { name: "Anguilla", code: "AI" },
    { name: "Antarctica", code: "AQ" },
    { name: "Antigua and Barbuda", code: "AG" },
    { name: "Argentina", code: "AR" },
    { name: "Armenia", code: "AM" },
    { name: "Aruba", code: "AW" },
    { name: "Australia", code: "AU" },
    { name: "Austria", code: "AT" },
    { name: "Azerbaijan", code: "AZ" },
    { name: "Bahamas", code: "BS" },
    { name: "Bahrain", code: "BH" },
    { name: "Bangladesh", code: "BD" },
    { name: "Barbados", code: "BB" },
    { name: "Belarus", code: "BY" },
    { name: "Belgium", code: "BE" },
    { name: "Belize", code: "BZ" },
    { name: "Benin", code: "BJ" },
    { name: "Bermuda", code: "BM" },
    { name: "Bhutan", code: "BT" },
    { name: "Bolivia", code: "BO" },
    { name: "Bosnia and Herzegovina", code: "BA" },
    { name: "Botswana", code: "BW" },
    { name: "Bouvet Island", code: "BV" },
    { name: "Brazil", code: "BR" },
    { name: "British Indian Ocean Territory", code: "IO" },
    { name: "Brunei Darussalam", code: "BN" },
    { name: "Bulgaria", code: "BG" },
    { name: "Burkina Faso", code: "BF" },
    { name: "Burundi", code: "BI" },
    { name: "Cambodia", code: "KH" },
    { name: "Cameroon", code: "CM" },
    { name: "Canada", code: "CA" },
    { name: "Cape Verde", code: "CV" },
    { name: "Cayman Islands", code: "KY" },
    { name: "Central African Republic", code: "CF" },
    { name: "Chad", code: "TD" },
    { name: "Chile", code: "CL" },
    { name: "China", code: "CN" },
    { name: "Christmas Island", code: "CX" },
    { name: "Cocos (Keeling) Islands", code: "CC" },
    { name: "Colombia", code: "CO" },
    { name: "Comoros", code: "KM" },
    { name: "Congo", code: "CG" },
    { name: "Congo, The Democratic Republic of the", code: "CD" },
    { name: "Cook Islands", code: "CK" },
    { name: "Costa Rica", code: "CR" },
    { name: "Cote DIvoire", code: "CI" },
    { name: "Croatia", code: "HR" },
    { name: "Cuba", code: "CU" },
    { name: "Cyprus", code: "CY" },
    { name: "Czech Republic", code: "CZ" },
    { name: "Denmark", code: "DK" },
    { name: "Djibouti", code: "DJ" },
    { name: "Dominica", code: "DM" },
    { name: "Dominican Republic", code: "DO" },
    { name: "Ecuador", code: "EC" },
    { name: "Egypt", code: "EG" },
    { name: "El Salvador", code: "SV" },
    { name: "Equatorial Guinea", code: "GQ" },
    { name: "Eritrea", code: "ER" },
    { name: "Estonia", code: "EE" },
    { name: "Ethiopia", code: "ET" },
    { name: "Falkland Islands (Malvinas)", code: "FK" },
    { name: "Faroe Islands", code: "FO" },
    { name: "Fiji", code: "FJ" },
    { name: "Finland", code: "FI" },
    { name: "France", code: "FR" },
    { name: "French Guiana", code: "GF" },
    { name: "French Polynesia", code: "PF" },
    { name: "French Southern Territories", code: "TF" },
    { name: "Gabon", code: "GA" },
    { name: "Gambia", code: "GM" },
    { name: "Georgia", code: "GE" },
    { name: "Germany", code: "DE" },
    { name: "Ghana", code: "GH" },
    { name: "Gibraltar", code: "GI" },
    { name: "Greece", code: "GR" },
    { name: "Greenland", code: "GL" },
    { name: "Grenada", code: "GD" },
    { name: "Guadeloupe", code: "GP" },
    { name: "Guam", code: "GU" },
    { name: "Guatemala", code: "GT" },
    { name: "Guernsey", code: "GG" },
    { name: "Guinea", code: "GN" },
    { name: "Guinea-Bissau", code: "GW" },
    { name: "Guyana", code: "GY" },
    { name: "Haiti", code: "HT" },
    { name: "Heard Island and Mcdonald Islands", code: "HM" },
    { name: "Holy See (Vatican City State)", code: "VA" },
    { name: "Honduras", code: "HN" },
    { name: "Hong Kong", code: "HK" },
    { name: "Hungary", code: "HU" },
    { name: "Iceland", code: "IS" },
    { name: "India", code: "IN" },
    { name: "Indonesia", code: "ID" },
    { name: "Iran, Islamic Republic Of", code: "IR" },
    { name: "Iraq", code: "IQ" },
    { name: "Ireland", code: "IE" },
    { name: "Isle of Man", code: "IM" },
    { name: "Israel", code: "IL" },
    { name: "Italy", code: "IT" },
    { name: "Jamaica", code: "JM" },
    { name: "Japan", code: "JP" },
    { name: "Jersey", code: "JE" },
    { name: "Jordan", code: "JO" },
    { name: "Kazakhstan", code: "KZ" },
    { name: "Kenya", code: "KE" },
    { name: "Kiribati", code: "KI" },
    { name: "S.Korea", code: "KP" },
    { name: "N.Korea", code: "KR" },
    { name: "Kuwait", code: "KW" },
    { name: "Kyrgyzstan", code: "KG" },
    { name: "Lao", code: "LA" },
    { name: "Latvia", code: "LV" },
    { name: "Lebanon", code: "LB" },
    { name: "Lesotho", code: "LS" },
    { name: "Liberia", code: "LR" },
    { name: "Libyan Arab Jamahiriya", code: "LY" },
    { name: "Liechtenstein", code: "LI" },
    { name: "Lithuania", code: "LT" },
    { name: "Luxembourg", code: "LU" },
    { name: "Macao", code: "MO" },
    { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
    { name: "Madagascar", code: "MG" },
    { name: "Malawi", code: "MW" },
    { name: "Malaysia", code: "MY" },
    { name: "Maldives", code: "MV" },
    { name: "Mali", code: "ML" },
    { name: "Malta", code: "MT" },
    { name: "Marshall Islands", code: "MH" },
    { name: "Martinique", code: "MQ" },
    { name: "Mauritania", code: "MR" },
    { name: "Mauritius", code: "MU" },
    { name: "Mayotte", code: "YT" },
    { name: "Mexico", code: "MX" },
    { name: "Micronesia, Federated States of", code: "FM" },
    { name: "Moldova, Republic of", code: "MD" },
    { name: "Monaco", code: "MC" },
    { name: "Mongolia", code: "MN" },
    { name: "Montserrat", code: "MS" },
    { name: "Morocco", code: "MA" },
    { name: "Mozambique", code: "MZ" },
    { name: "Myanmar", code: "MM" },
    { name: "Namibia", code: "NA" },
    { name: "Nauru", code: "NR" },
    { name: "Nepal", code: "NP" },
    { name: "Netherlands", code: "NL" },
    { name: "Netherlands Antilles", code: "AN" },
    { name: "New Caledonia", code: "NC" },
    { name: "New Zealand", code: "NZ" },
    { name: "Nicaragua", code: "NI" },
    { name: "Niger", code: "NE" },
    { name: "Nigeria", code: "NG" },
    { name: "Niue", code: "NU" },
    { name: "Norfolk Island", code: "NF" },
    { name: "Northern Mariana Islands", code: "MP" },
    { name: "Norway", code: "NO" },
    { name: "Oman", code: "OM" },
    { name: "Pakistan", code: "PK" },
    { name: "Palau", code: "PW" },
    { name: "Palestinian Territory, Occupied", code: "PS" },
    { name: "Panama", code: "PA" },
    { name: "Papua New Guinea", code: "PG" },
    { name: "Paraguay", code: "PY" },
    { name: "Peru", code: "PE" },
    { name: "Philippines", code: "PH" },
    { name: "Pitcairn", code: "PN" },
    { name: "Poland", code: "PL" },
    { name: "Portugal", code: "PT" },
    { name: "Puerto Rico", code: "PR" },
    { name: "Qatar", code: "QA" },
    { name: "Reunion", code: "RE" },
    { name: "Romania", code: "RO" },
    { name: "Russian Federation", code: "RU" },
    { name: "RWANDA", code: "RW" },
    { name: "Saint Helena", code: "SH" },
    { name: "Saint Kitts and Nevis", code: "KN" },
    { name: "Saint Lucia", code: "LC" },
    { name: "Saint Pierre and Miquelon", code: "PM" },
    { name: "Saint Vincent and the Grenadines", code: "VC" },
    { name: "Samoa", code: "WS" },
    { name: "San Marino", code: "SM" },
    { name: "Sao Tome and Principe", code: "ST" },
    { name: "Saudi Arabia", code: "SA" },
    { name: "Senegal", code: "SN" },
    { name: "Serbia and Montenegro", code: "CS" },
    { name: "Seychelles", code: "SC" },
    { name: "Sierra Leone", code: "SL" },
    { name: "Singapore", code: "SG" },
    { name: "Slovakia", code: "SK" },
    { name: "Slovenia", code: "SI" },
    { name: "Solomon Islands", code: "SB" },
    { name: "Somalia", code: "SO" },
    { name: "South Africa", code: "ZA" },
    { name: "South Georgia and the South Sandwich Islands", code: "GS" },
    { name: "Spain", code: "ES" },
    { name: "Sri Lanka", code: "LK" },
    { name: "Sudan", code: "SD" },
    { name: "Suriname", code: "SR" },
    { name: "Svalbard and Jan Mayen", code: "SJ" },
    { name: "Swaziland", code: "SZ" },
    { name: "Sweden", code: "SE" },
    { name: "Switzerland", code: "CH" },
    { name: "Syrian Arab Republic", code: "SY" },
    { name: "Taiwan, Province of China", code: "TW" },
    { name: "Tajikistan", code: "TJ" },
    { name: "Tanzania, United Republic of", code: "TZ" },
    { name: "Thailand", code: "TH" },
    { name: "Timor-Leste", code: "TL" },
    { name: "Togo", code: "TG" },
    { name: "Tokelau", code: "TK" },
    { name: "Tonga", code: "TO" },
    { name: "Trinidad and Tobago", code: "TT" },
    { name: "Tunisia", code: "TN" },
    { name: "Turkey", code: "TR" },
    { name: "Turkmenistan", code: "TM" },
    { name: "Turks and Caicos Islands", code: "TC" },
    { name: "Tuvalu", code: "TV" },
    { name: "Uganda", code: "UG" },
    { name: "Ukraine", code: "UA" },
    { name: "United Arab Emirates", code: "AE" },
    { name: "United Kingdom", code: "GB" },
    { name: "United States", code: "US" },
    { name: "United States Minor Outlying Islands", code: "UM" },
    { name: "Uruguay", code: "UY" },
    { name: "Uzbekistan", code: "UZ" },
    { name: "Vanuatu", code: "VU" },
    { name: "Venezuela", code: "VE" },
    { name: "Viet Nam", code: "VN" },
    { name: "Virgin Islands, British", code: "VG" },
    { name: "Virgin Islands, U.S.", code: "VI" },
    { name: "Wallis and Futuna", code: "WF" },
    { name: "Western Sahara", code: "EH" },
    { name: "Yemen", code: "YE" },
    { name: "Zambia", code: "ZM" },
    { name: "Zimbabwe", code: "ZW" }
  ]
};

export default typelists;
